import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { DownloadSimple } from "@phosphor-icons/react";

function daysAgo(n) { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString().slice(0, 10); }

export default function LocationCompliance() {
  const [from, setFrom] = useState(daysAgo(30));
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
  const [rows, setRows] = useState([]);

  async function load() {
    try {
      const { data } = await api.get(`/locations/compliance?from_date=${from}&to_date=${to}`);
      setRows(data);
    } catch (e) { /* noop */ }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [from, to]);

  function exportCSV() {
    const head = ["Employee ID", "Name", "Events", "Valid", "Mismatch", "Suspicious",
                  "Avg Distance (m)", "Max Distance (m)", "Compliance %"];
    const lines = [head.join(",")];
    rows.forEach((r) => lines.push([r.employee_id, r.employee_name, r.events,
        r.valid, r.mismatch, r.suspicious, r.avg_distance, r.max_distance, r.compliance_pct].join(",")));
    const blob = new Blob([lines.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `compliance-${from}-${to}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#E50914] mb-2">Reports</p>
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight">Location Compliance</h1>
          <p className="text-xs text-zinc-500 mt-1">Valid attendance vs location mismatches by employee.</p>
        </div>
        <div className="flex gap-3 items-end">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1">From</div>
            <Input type="date" value={from} onChange={(e)=>setFrom(e.target.value)}
                   className="bg-[#16161C] border-[#2D2D35] h-10 w-40 [color-scheme:dark]" data-testid="lc-from" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1">To</div>
            <Input type="date" value={to} onChange={(e)=>setTo(e.target.value)}
                   className="bg-[#16161C] border-[#2D2D35] h-10 w-40 [color-scheme:dark]" data-testid="lc-to" />
          </div>
          <Button onClick={exportCSV} className="bg-[#E50914] hover:bg-[#C80812] h-10" data-testid="lc-export">
            <DownloadSimple size={14} className="mr-1" /> CSV
          </Button>
        </div>
      </div>

      <div className="bg-[#16161C] border border-[#2D2D35] rounded-md overflow-hidden">
        <table className="w-full" data-testid="compliance-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-zinc-500 border-b border-[#2D2D35]">
              <th className="text-left p-3">Employee</th>
              <th className="text-right p-3">Events</th>
              <th className="text-right p-3">Valid</th>
              <th className="text-right p-3">Mismatch</th>
              <th className="text-right p-3">Suspicious</th>
              <th className="text-right p-3">Avg (m)</th>
              <th className="text-right p-3">Max (m)</th>
              <th className="text-right p-3">Compliance</th>
            </tr>
          </thead>
          <tbody className="font-mono text-sm">
            {rows.map((r) => (
              <tr key={r.employee_id} className="border-b border-[#2D2D35]/60 hover:bg-[#1C1C24]">
                <td className="p-3">
                  <div className="text-white text-sm">{r.employee_name}</div>
                  <div className="text-[10px] text-zinc-500">{r.employee_id}</div>
                </td>
                <td className="p-3 text-right">{r.events}</td>
                <td className="p-3 text-right text-[#22C55E]">{r.valid}</td>
                <td className="p-3 text-right text-[#F59E0B]">{r.mismatch}</td>
                <td className="p-3 text-right text-[#FF3B30]">{r.suspicious}</td>
                <td className="p-3 text-right">{r.avg_distance}</td>
                <td className="p-3 text-right">{r.max_distance}</td>
                <td className="p-3 text-right">
                  <span className={`text-xs font-semibold ${r.compliance_pct >= 90 ? "text-[#22C55E]" : r.compliance_pct >= 70 ? "text-[#F59E0B]" : "text-[#FF3B30]"}`}>
                    {r.compliance_pct}%
                  </span>
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan="8" className="text-center text-zinc-500 p-8 text-sm">No attendance in the selected range.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
